/**
 * Setup service worker cache cleanup
 * Clears all runtime caches except those in the whitelist
 * This removes caches from old app versions
 */
export default function setupCacheCleanup() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      if (registration.active) {
        // Clean up old caches on each SW activation
        const whitelist = new Set([
          'assets-cache',
          'images-cache',
          'html-cache',
          'workbox-precache',
        ]);
        caches.keys().then(names => {
          names.forEach(name => {
            if (!whitelist.has(name)) {
              caches.delete(name);
            }
          });
        });
      }
    });
  }
}
